import styled from 'styled-components';

// Acordeão do protótipo: cabeçalho com ícone do tipo, resumo, selo e botão de abrir.
export const Container = styled.article`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: #fff;

  &.status-confirmado {
    border-color: #b1dfbb;
  }

  &.is-ignored {
    background: #f8f9fa;

    .requirement-title strong {
      color: #6c757d;
      text-decoration: line-through;
    }
  }

  .min-w-0 {
    min-width: 0;
  }

  .requirement-head {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
  }

  .requirement-title {
    flex: 1;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    min-width: 0;
    border: 0;
    background: transparent;
    padding: 0;
    text-align: left;

    strong {
      display: block;
      color: #21354a;
      font-weight: 600;
      word-break: break-word;
    }

    small {
      display: block;
      font-size: 13px;
      color: #6c757d;
    }
  }

  .requirement-kind {
    color: #6c757d;
    margin-top: 2px;
  }

  .requirement-manual {
    font-size: 12px;
    color: #495057;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 2px 7px;
    white-space: nowrap;
  }

  .requirement-badge {
    display: inline-flex;
    align-items: center;
    border-radius: 4px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .badge-status-pendente {
    background: #f8d7da;
    color: #721c24;
  }

  .badge-status-aguardando_revisao {
    background: #fff3cd;
    color: #856404;
  }

  .badge-status-confirmado {
    background: #d4edda;
    color: #155724;
  }

  .badge-status-ignorada {
    background: #e9ecef;
    color: #495057;
  }

  .requirement-toggle {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    border: 0;
    border-radius: 4px;
    background: #6c757d;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #5a6268;
    }

    .material-icons-outlined {
      transition: transform 0.2s;
    }

    .rotated {
      transform: rotate(180deg);
    }
  }

  .requirement-body {
    border-top: 1px solid #dee2e6;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    h3 {
      font-size: 15px;
      font-weight: 600;
      color: #21354a;
      margin-bottom: 4px;
    }

    blockquote {
      background: #f8f9fa;
      border-left: 3px solid #dee2e6;
      padding: 10px 12px;
      margin: 0;
      font-size: 13px;
      font-style: italic;
      color: #495057;
      white-space: pre-line;
      word-break: break-word;

      small {
        display: block;
        margin-top: 5px;
        font-style: normal;
      }

      button {
        border: 0;
        background: none;
        color: #007bff;
        padding: 0;
        display: inline-flex;
        align-items: center;
        gap: 3px;

        .material-icons-outlined {
          font-size: 15px;
        }
      }
    }
  }

  .requirement-actions {
    margin-top: -8px;
  }

  .requirement-files {
    margin-bottom: 0 !important;
  }

  .requirement-files li + li {
    border-top: 1px solid #dee2e6;
  }

  .file-name {
    word-break: break-word;
  }

  .portal-alert {
    display: flex;
    align-items: flex-start;
    gap: 10px;

    .material-icons-outlined {
      font-size: 20px;
    }

    strong,
    span {
      display: block;
    }
  }
`;
